import { render, staticRenderFns } from "./Cockpit.vue?vue&type=template&id=5d2830ac&scoped=true"
import script from "./Cockpit.vue?vue&type=script&lang=js"
export * from "./Cockpit.vue?vue&type=script&lang=js"
import style0 from "./Cockpit.vue?vue&type=style&index=0&id=5d2830ac&prod&scoped=true&lang=css"
import style1 from "./Cockpit.vue?vue&type=style&index=1&id=5d2830ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2830ac",
  null
  
)

export default component.exports